import React, { useEffect, useState } from 'react';
import * as styles from './JoinClubSidebar.module.css';

const Sidebar = ({ show, handleOpen }) => {
  const [sidebarStyle, setSidebarStyle] = useState(styles.hide);
  
  useEffect(() => {
    if (show) {
      setSidebarStyle(styles.show);
    } else {
      setSidebarStyle(styles.hide);
    }
  }, [show]);

  const closeSidebar = () => {
    setSidebarStyle(styles.hide);
  }
  
  return (
    <div className={`${styles.root} ${sidebarStyle}`}>
      <span className={styles.open} onClick={() => handleOpen(true)}>Get $10 Off</span>
      <button className={styles.close} onClick={closeSidebar}>&times;</button>
    </div>
  );
};

export default Sidebar;